// src/locales/ta/orderAssignment.js
export const orderAssignment = {
  specialNote: 'சிறப்பு குறிப்பு',
  configurationTitle: "Order Assignment Rules",
  configurationSubtitle: "Auto Assignment rules அமைக்கவும்",
  manualAssignmentTitle: "Manual Order Assignment",
  manualAssignmentSubtitle: "Bulk ஆர்டர் ஒதுக்கீடு",
  myWorkQueue: "எனது Work Queue",
  workQueueSubtitle: "உங்களுக்கு ஒதுக்கப்பட்ட Orders நிர்வகிக்கவும்",

  shopSelection: "Shop Selection",
  selectShop: "Shop தேர்ந்தெடுக்கவும்",
  selectShopPlaceholder: "Shop தேர்ந்தெடுக்கவும்",
  shopWithOrderCount: "{{name}} ({{type}}) - {{count}} orders",

  autoAssignmentStatus: "Auto Assignment Status",
  autoAssignmentEnabled: "Auto-Assignment Enabled",
  autoAssignmentDisabled: "Auto-Assignment Disabled",
  enabledDescription: "புதிய Orders கீழே உள்ள Rules படி auto assign செய்யப்படும்",
  disabledDescription: "Auto assign செய்ய Enable செய்யவும்",

  grandTotalRules: "Grand Total Rules",
  grandTotalRulesInfo: "Grand Total அடிப்படையில் பயனர்களுக்கு orders assign செய்யுங்கள்.",
  addRule: "Rule சேர்க்கவும்",
  deleteRule: "Rule நீக்கு",
  ruleNumber: "Rule #{{number}}",
  minimumAmount: "குறைந்தபட்ச Amount",
  maximumAmount: "அதிகபட்ச Amount",
  noMinimum: "குறைந்தபட்சம் இல்லை",
  noMaximum: "அதிகபட்சம் இல்லை",
  assignTo: "Assign செய்ய",
  selectUsers: "பயனர்களை தேர்ந்தெடுக்கவும்...",
  searchUsers: "பயனர்களை தேடவும்...",
  rangePreview: "Range: {{min}} - {{max}}",
  rangePreviewCurrency: "Range: {{min}} - {{max}}",
  rangePreviewInfinity: "Range: {{min}} - ∞",
  rangePreviewZeroToInfinity: "Range: 0 - ∞",
  noGrandTotalRules: "Rules configure செய்யப்படவில்லை",
  addFirstRule: "முதல் Rule சேர்க்கவும்",
  to: "to",

  productRules: "Product Rules",
  productRulesInfo:
    "ஒரு Order குறிப்பிட்ட Products-ஐ கொண்டிருக்கும்போது assign செய்யப்படும்",
  products: "Products",
  selectProducts: "Products தேர்ந்தெடுக்கவும்...",
  searchProducts: "Products தேடவும்...",
  noProductRules: "Product Rules configure செய்யப்படவில்லை",
  allProducts: "அனைத்து Products",

  defaultAssignment: "Default Assignment",
  defaultAssignmentInfo:
    "Rules-க்கு உட்படாத Orders Default Users-க்கு Assign செய்யப்படும்.",
  defaultAssignees: "Default Assign செய்வோர்",
  selectDefaultUsers: "Default Users-ஐ தேர்ந்தெடுக்கவும்...",
  defaultAssignmentNote:
    "Rules-க்கு பொருந்தாத Orders இங்கே Assign செய்யப்படும்",

  assignmentConfiguration: "Assignment Settings",
  orderSelection: "Order Selection (Optional)",
  ordersEligible: "{{count}} orders eligible",
  clearSelection: "தேர்வு நீக்கவும்",
  selectAllOrders: "அனைத்து Orders-ஐ தேர்வுசெய்",
  assignmentPreview: "Preview",
  ordersToAssign: "Assign செய்ய Orders",
  usersAssigned: "Assign செய்யப்பட்ட Users",
  unassignedOrders: "Assign செய்யாத Orders",
  unbalancedWarning: "Unbalanced",
  showPreview: "Preview காண்பிக்கவும்",
  hidePreview: "மறைக்கவும்",
  executeAssignment: "Assign செய்யவும்",
  executing: "Assign செய்யப்படுகிறது...",
  executeAssignmentWithCount: "Assign ({{count}} orders)",
  moreOrders: "+{{count}} Orders",
  unassigned: "Assign செய்யப்படவில்லை",
  ordersCount: "{{count}} orders",

  totalAssigned: "மொத்த Assign செய்யப்பட்டவை",
  confirmedVerified: "உறுதி செய்யப்பட்டது (பணம் சரிபார்க்கப்பட்டது)",
  confirmedNotVerified: "உறுதி செய்யப்பட்டது (பணம் சரிபார்க்கப்படவில்லை)",
  orderValue: "Order Value",
  statusBreakdown: "Status Breakdown",
  assignmentStats: "Assignment புள்ளிவிவரம்",
  assignedOrders: "Assign செய்யப்பட்ட Orders",
  assignmentDistribution: "Assignment Distribution",
  loadingWorkQueue: "Orders Load செய்யப்படுகிறது...",
  unableToLoadWorkQueue: "Load செய்ய முடியவில்லை",
  noOrdersAssigned: "Orders Assign செய்யப்படவில்லை",
  noOrdersAssignedDescription: "உங்களுக்கு Orders Assign செய்யப்படவில்லை",
  noOrdersFound: "Orders கிடைக்கவில்லை",
  noOrdersFoundDescription: "Filter-க்கு பொருந்தும் Orders இல்லை",
  ordersSelected: "{{count}} orders selected",
  searchPlaceholder: "Order அல்லது Customer பெயரால் தேடவும்…",

  order: "Order",
  orderNumber: "Order Number",
  paymentMethods: "Payment Methods",
  payments: "பணம்",
  customer: "Customer",
  customerName: "Customer Name",
  status: "Status",
  total: "Total",
  assigned: "Assigned",
  orderStatus: "Order Status",
  statusReason: "Reason",
  allStatuses: "அனைத்து Status",
  allReasons: "அனைத்து காரணங்கள்",
  minGrandTotal: "குறைந்தபட்ச Grand Total",
  maxGrandTotal: "அதிகபட்ச Grand Total",

  orderDetails: "Order Details",
  orderInformation: "Order தகவல்",
  orderDate: "Order தேதி",
  grandTotal: "Grand Total",
  currentStatus: "தற்போதைய நிலை",
  customerInformation: "Customer தகவல்",
  name: "பெயர்",
  phone: "Phone",
  email: "Email",
  address: "முகவரி",
  orderItems: "Order Items",
  sku: "SKU",

  updateStatus: "Status Update",
  updateOrderStatus: "Order Status Update",
  newStatus: "New Status",
  selectStatus: "Status தேர்வுசெய்...",
  selectReason: "Reason தேர்வுசெய்...",
  holdUntilDate: "Hold தேதி",
  holdUntil: "Hold Until",
  updateStatusButton: "Update Status",
  updating: "Updating...",
  confirmStatusChange: 'இந்த Order ஐ "{{status}}" எனக் குறிக்க வேண்டுமா?',

  bulkUpdateStatus: "Bulk Status Update",
  aboutToUpdateOrders: "{{count}} Orders update செய்யப் போகிறீர்கள்",
  bulkUpdateDescription:
    "தேர்ந்தெடுக்கப்பட்ட அனைத்து Orders-னும் ஒரே Status-க்கு update செய்யப்படும்.",
  updateOrdersCount: "{{count}} Orders Update",

  assignmentComplete: "Assignment முடிந்துவிட்டது",
  successfullyAssigned: "{{count}} Orders Assign செய்யப்பட்டது",
  assignmentFailed: "Assign செய்ய முடியவில்லை",

  lastUpdated: "Last Updated: {{date}}",
  updatedBy: "By: {{name}}",
  updatedByUser: "By: {{name}}",
  updatedByUnknown: "By: Unknown",
  assignedAt: "Assign செய்யப்பட்ட நேரம்",

  backToOrders: "Orders க்கு திரும்ப",
  saveRules: "Rules Save செய்",
  cancel: "Cancel",
  saving: "Saving...",

  atLeastOneUser: "குறைந்தது ஒரு User ஐயாவது தேர்ந்தெடுக்கவும்",
  maxMustBeGreaterThanMin: "Maximum என்பது Minimum-ஐ விட பெரியதாக இருக்க வேண்டும்",
  atLeastOneProduct: "குறைந்தது ஒரு Product ஐயாவது தேர்ந்தெடுக்கவும்",
  atLeastOneRuleOrDefault:
    "Auto-Assignment enabled இருந்தால் Rule அல்லது Default Users தேவை",
  noOrdersAvailable: "Assign செய்ய Orders இல்லை",
  noOrdersCanBeAssigned: "Rules-க்கு பொருந்தும் Orders இல்லை",
  shopRequired: "Shop தேர்வு அவசியம்",
  selectAtLeastOneOrder: "ஒரு Order ஐயாவது தேர்ந்தெடுக்கவும்",
  pleaseSelectStatus: "Status தேர்வு செய்யவும்",
  pleaseSelectReason: "Reason தேர்வு செய்யவும்",
  pleaseSelectHoldDate: "Hold தேதி தேர்வு செய்யவும்",

  rulesSavedSuccess: "Rules Save செய்யப்பட்டது",
  rulesSaveFailed: "Rules Save செய்ய முடியவில்லை",
  loadingConfig: "Config Load செய்யப்படுகிறது...",
  loadingConfigMessage: "Rules Load செய்யப்படுகிறது...",
  loadingAssignmentData: "Assignment Data Load செய்யப்படுகிறது...",
  loadingAssignmentMessage: "தரவு Load செய்யப்படுகிறது...",
  loadDataFailed: "Data Load செய்ய முடியவில்லை. Refresh செய்யவும்.",
  loadOrdersFailed: "Orders Load செய்ய முடியவில்லை",
  unsavedChanges: "Unsaved changes உள்ளது. Save செய்யாமல் வெளியேற வேண்டுமா?",
  fixValidationErrors: "Errors சரிசெய்யவும்",
  fixValidationBeforeExecuting:
    "Assign செய்ய முன்னர் validation errors சரிசெய்யவும்",
  confirmAssignment: "{{count}} Orders Assign செய்யவா?",
  confirmAssignmentWithUnassigned:
    "{{assigned}} Orders Assign செய்யப்படும்.\n\n{{unassigned}} Orders Assign ஆகாது.",
  confirmAssignmentUnbalanced:
    "{{assigned}} Orders Assign செய்யப்படும்.\n\n{{unassigned}} Orders Assign ஆகாது.\n\nWarning: Unbalanced Assignment!",
  unassignedWarning: "Warning: {{count}} Orders Assign ஆகாது.",
  unbalancedAssignmentWarning:
    "Warning: Assignment অসমமானதாக உள்ளது",
  noChanges: "Changes இல்லை",
  orderStatusUpdated: "Order Status update செய்யப்பட்டது",
  failedToUpdateStatus: "Order Status update செய்ய முடியவில்லை",
  bulkUpdateSuccess: "{{count}} Orders update செய்யப்பட்டது",
  failedToUpdateSomeOrders: "சில Orders update செய்ய முடியவில்லை",
  failedToUpdateOrders: "Orders update செய்ய முடியவில்லை",
  assignedUser: "ஒதுக்கப்பட்ட பயனர்",
  notAssigned: "ஒதுக்கப்படவில்லை",
  assignedTo: "ஒதுக்கப்பட்டவர்",
};
